import type { LucideIcon } from 'lucide-react';
import { FileText, Send, Clock, CheckCircle2, XCircle } from 'lucide-react';

export const STATUS_COLORS: Record<string, { label: string; className: string; icon: LucideIcon }> = {
  draft: { label: 'Draft', className: 'bg-gray-50 !text-gray-700 border-gray-300', icon: FileText },
  submitted: { label: 'Submitted', className: 'bg-blue-50 !text-blue-700 border-blue-300', icon: Send },
  under_review: { label: 'Under Review', className: 'bg-yellow-50 !text-yellow-700 border-yellow-300', icon: Clock },
  approved: { label: 'Approved', className: 'bg-green-50 !text-green-700 border-green-300', icon: CheckCircle2 },
  rejected: { label: 'Rejected', className: 'bg-red-50 !text-red-700 border-red-300', icon: XCircle },
  closed: { label: 'Closed', className: 'bg-purple-50 !text-purple-700 border-purple-300', icon: CheckCircle2 },
};

export const RISK_COLORS: Record<string, { label: string; className: string }> = {
  low: { label: 'Low', className: 'bg-green-50 !text-green-700 border-green-300' },
  medium: { label: 'Medium', className: 'bg-yellow-50 !text-yellow-700 border-yellow-300' },
  high: { label: 'High', className: 'bg-orange-50 !text-orange-700 border-orange-300' },
  critical: { label: 'Critical', className: 'bg-red-50 !text-red-700 border-red-300' },
};

export const STATUS_TIMELINE = ['draft', 'submitted', 'under_review', 'approved', 'closed'];
